var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['c-dashboard', { bg: _vm.hasBackground }]},[(_vm.currentBlock)?_c('Breadcrumbs',{attrs:{"currentBlock":_vm.currentBlock}}):_vm._e(),_c('SheetView',{attrs:{"blockId":_vm.blockId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }